import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class LoyaltyApi {
	// --- Settings (global on/off switch) ---
	async getSettings(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/loyalty/settings' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateSettings(data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/loyalty/settings' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// --- Programs CRUD (URL shape mirrors customers) ---
	async listPrograms(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/loyalty/programs' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getProgram(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/loyalty/programs/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getProgramCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/loyalty/programs/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async createProgram(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/loyalty/programs/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getProgramUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/loyalty/programs/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateProgram(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/loyalty/programs/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async deleteProgram(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/loyalty/programs/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// --- Staff: customer points (in customer detail) ---
	async customerPoints(customerId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/customers/' + customerId + '/points' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async customerPointsHistory(customerId, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/customers/' + customerId + '/points/history' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async adjustCustomerPoints(customerId, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/customers/' + customerId + '/points/adjust' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// --- POS: redeem on a bill ---
	async billLoyalty(billId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/bills/' + billId + '/loyalty' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async redeem(billId, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/bills/' + billId + '/loyalty/redeem' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancelRedeem(billId, reference, isRestock = true) {
		try {
			// is_restock: ของแถม (free_product) เลือกคืนวัตถุดิบเข้าสต๊อกไหม — ลงนามไปกับ query
			const response = await axios.delete(BASE_URI + '/v1/bills/' + billId + '/loyalty/redeem/' + reference + signature('is_restock=' + (isRestock ? 1 : 0)), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Loyalty = new LoyaltyApi();
